import http from '../_httpHandlers';
import { config } from '../_config';
import { ILinks, ILinksService } from '../_types/interfaces/IRoute';

const linksApi = config.backendAddress;

const getLinksList = async (): Promise<Array<ILinks>> => {
    return await http.get(linksApi + "/linkIndiv");
};

export const linkService: ILinksService = {
    getLinksList,
};